import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import EventCrewList from 'components/event/CrewList';
import UserContext from 'containers/contexts/UserContext.js';
import {
  getCurrentEventCrew,
  updateRoleInCurrentEvent,
  deleteRoleInCurrentEvent,
  resendInviteInCurrentEvent,
  updateAvailableTools
} from 'actions/Event';

import { showModal } from 'actions';
import Paths from 'AppPaths';

import { matchPath } from 'react-router';
import { connect } from 'react-redux';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';
import { shouldHaveFeature } from '@shoflo/polymer/helpers/Feature/Feature';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { EVENT_INVITE_CREW, INVITE_CREW_MODAL } from 'constants/ModalTypes';

function Unconnected({
  eventCrew,
  getCurrentEventCrew,
  showModal,
  updateRoleInCurrentEvent,
  deleteRoleInCurrentEvent,
  resendInviteInCurrentEvent,
  updateAvailableTools,
  teamId,
  eventId,
  isLoading,
  team
}) {
  useEffect(() => {
    getCurrentEventCrew();
  }, [eventId, getCurrentEventCrew]);

  const user = useContext(UserContext);
  const targetModal = shouldHaveFeature('event-crew-tools')
    ? INVITE_CREW_MODAL
    : EVENT_INVITE_CREW;

  const isEventAdmin =
    RoleHelper.hasEventAdminRole(user, teamId, eventId) ||
    RoleHelper.hasTeamAdminRole(user, teamId);

  const inviteCrewButton = isEventAdmin ? (
    <Button
      data-testid="inviteCrewButton"
      color="primary"
      onClick={showModal.bind(null, targetModal)}
    >
      Invite crew
    </Button>
  ) : null;

  return (
    <EventCrewList
      {...{ teamId, eventId }}
      users={eventCrew}
      inviteCrewButton={inviteCrewButton}
      hasEventManagementControls={isEventAdmin}
      onChangeRoleClick={updateRoleInCurrentEvent}
      onDeleteClick={deleteRoleInCurrentEvent}
      onResendInviteClick={resendInviteInCurrentEvent}
      isLoading={isLoading}
      onAvailableToolsChanged={updateAvailableTools}
      team={team}
      showModal={showModal}
    />
  );
}

const PropMapper = ({ eventCrew, isDataLoading, team }, { match }) => {
  const eventMatch = matchPath(match.url, {
    path: Paths.EventDash
  });

  const eventId = eventMatch ? eventMatch.params.eventId : null;
  const teamId = eventMatch ? eventMatch.params.teamId : null;

  return {
    eventCrew,
    teamId,
    eventId,
    isLoading: isDataLoading,
    team
  };
};

export default withRouter(
  connect(PropMapper, {
    getCurrentEventCrew,
    updateRoleInCurrentEvent,
    deleteRoleInCurrentEvent,
    resendInviteInCurrentEvent,
    showModal,
    updateAvailableTools
  })(Unconnected)
);

export { Unconnected, PropMapper };
